<template>
    <div class="settings">
      <PaymentTypeRow
        :keyboardShows="showKeyboard"
      >
        <span slot="label" :style="{'fontWeight': 'bold'/* difference ? 'bold' : '' */, 'top': '15px', 'position': 'relative'}">
          {{ text }} {{ priceFormt }}
        </span>
        <!--             @input="search = result"
            @keydown.esc="cancelSearch" -->
            <!--             @blur="(input) => { focusedElement(true, input.target.value) }" -->
        <v-text-field
            ref="searchField"
            hide-details
            v-model="value"
            v-if="!difference"
            :disabled="typeof (currentValue) === 'number' || currentTrrPaymentId.id === type"
            :readonly="student"
            outlined
            slot="selection"
            class="pa-0"
            :style="{'height': 'fit-content', 'paddingBottom': '5px !important', 'text-align': 'right'}"
            @click.prevent.stop="() => { $emit('click'); }"
            @keydown.enter.prevent="(input) => { focusedElement(true, input.target.value) }"
            @keydown.tab.prevent="(input) => { focusedElement(true, input.target.value) }"
            @focus="(input) => { input.target.select(); focusedElement(false) }"
        ></v-text-field>
        <v-text-field
            v-else
            disabled
            class="pa-0"
            hide-details
            readonly
            slot="selection"
            :style="{'height': 'fit-content', 'border': '2px solid #b2b2b2', 'border-radius': '5px', 'padding': '0', 'text-align': 'right'}"
            v-model="currentValueString"
            type="string"
        ></v-text-field>
        <v-btn
          slot="submit"
          class="q-mt-md q-mr-md"
          :disabled="!timeoutLifted || (!difference && !selected && valueLeft == 0) || (!difference && currentTrrPaymentId.id == type && setAsDifference)"
          style="margin: 0;"
          :style="{'fontSize': student ? '16px' : '', width: 'max-content', backgroundColor: !difference ? !selected ? setAsDifference ? this.differenc : this.choosen : this.clear : this.clear, color: 'white'}"
          @click="save">{{ !selected ? difference ? 'POČISTI' : setAsDifference ? 'Razlika' : 'Izberi' : 'Počisti' }}</v-btn>
      </PaymentTypeRow>
    </div>
  </template>

  <script>
  import PaymentTypeRow from '../components/PaymentTypeRow'
  // import ButtonPrimarySmall from 'components/buttons/ButtonPrimarySmall'
  import { mapGetters } from 'vuex'

  /* debounce for multiple simultaneous components. */
  function debounce (fn, delay) {
    var thatUidToTimeoutID = {}
    return function () {
      var args = arguments
      var that = this
      clearTimeout(thatUidToTimeoutID[that._uid])
      thatUidToTimeoutID[that._uid] = setTimeout(() => fn.apply(that, args), delay)
    }
  }

  export default {
    components: {
      PaymentTypeRow,
      // ButtonPrimarySmall,
      // Keyboard: () => import('./popups/PopupVirtualNumericKeyboard'),
    },
    props: {
      text: {
        required: true,
        type: String,
      },
      currentValue: {
        required: false,
        type: Number,
      },
      currentValueString: {
        type: String,
      },
      valueLeft: {
        type: String,
      },
      type: {
        type: Number,
      },
      currentTrrPaymentId: {
        type: Object,
      },
    },
    data () {
      return {
        syncingData: false,
        value: 0.00,
        fakeValue: '',
        showKeyboard: false,
        timeoutLifted: true,
        selected: false,
        previousLastValue: 0.00,
        setAsDifference: false,
        choosen: '#51AE30',
        clear: '#FA0960',
        differenc: '#1A81E3',
      }
    },
    computed: {
      ...mapGetters(['isMenuOpen', 'isMobile']),
      priceFormt () {
        return this.currentValue ? `(${(this.currentValue).toFixed(2).replace('.', ',')}€)` : ''
      },
      student () {
        return this.text.toLocaleLowerCase().includes('štud')
      },
      difference () {
        return this.text.toLocaleLowerCase().includes('razlika')
      },
      /* studentValue () {
        return this.student ? this.currentValue : this.value
      }, */
    },
    created () {
      document.addEventListener('contextmenu', function (event) {
        /* if (event.target.nodeName !== 'INPUT' && event.target.type !== 'text' && event.target.nodeName !== 'TEXTAREA') {
            event.preventDefault();
        } */
        event.preventDefault()
      })
      this.$emit('ready')
    },
    mounted () {
      // console.log('redady')
    },
    methods: {
      reset () {
        console.log('spot')
        this.$refs.searchField.reset()
      },
      setChanged (val) {
        if (this.showKeyboard) {
          this.fakeValue = val
        }
        if (!this.showKeyboard) {
          // console.log(val)
        }
      },
      focusedElement (shouldSetFalse, valueToSet) {
        if (this.showKeyboard && shouldSetFalse) {
          this.value = 'drvo'
          this.showKeyboard = false
          this.$nextTick(() => {
            this.value = valueToSet.replace('.', ',')
          })
          this.fakeValue = ''
          return
        }
        /* if (this.$refs.keyboard) {
          this.$refs.keyboard.clearVnos()
          this.showKeyboard = true
        } */
        this.showKeyboard = true
      },
      save () {
        if (this.selected) {
          this.$emit('clearCurrent', this.value.replace(',', '.'))
          this.selected = false
          return
        }

        if (!this.difference) this.selected = true
        var parsedvalue = 0
        if (typeof (this.value) === 'string') {
          parsedvalue = parseFloat(this.value.replace(',', '.'))
        }
        if (!parsedvalue && !this.currentValue) {
          this.value = this.valueLeft
        } else {
          if (this.currentValue) {
            this.value = this.currentValue.toFixed(2)
          }
        }
        if (this.difference) {
          this.$emit('clear')
        } else {
          if ((this.student || this.currentValue)/*  && this.setAsDifference */) {
            this.value = this.currentValue
            this.$emit('openPopup', { name: this.text, ask_for_quantity: true, id: this.type, value: this.value })
          }
          // this.$emit('togglePaymentType', this.value)
        }
      },
      setFilterDebounced: debounce(function (newVal, oldVal) {
        var result = newVal || '0,00'
        if (typeof (newVal) === 'string') {
          if (newVal === '0') {
            result = '0,00'
          } else {
            if (!number_test(parseFloat(newVal.replace(',', '.')))) {
              const noDecimalPlaces = !newVal.includes('.') && !newVal.includes(',')
              if (noDecimalPlaces) {
                result = newVal + ',00'
              } else {
                result = newVal.replace('.', ',')
              }
            } else {
              // console.log('kegl: ', newVal)
              const decimalPlacesDot = newVal.split('.')[1]
              const decimalPlacesComma = newVal.split(',')[1]

              const truth = decimalPlacesDot ? decimalPlacesDot.length < 2 : decimalPlacesComma ? decimalPlacesComma.length < 2 : ''

              if (truth) {
                newVal += '0'
              }
              // console.log(truth, decimalPlacesComma?.length, decimalPlacesDot?.length, newVal)
              result = newVal.replace('.', ',')
            }
          }
        } else {
          if (!newVal) {
            result = '0,00'
          } else {
            result = newVal.toFixed(2).replace('.', ',')
          }
        }
        // this.timeoutLifted = true
        // if (result.split('.').length > 2 || result.split(',').length > 2 || (result.includes('.') && result.includes(','))) {
        // this.selected = false
        // this.timeoutLifted = true
        // return
        // }
        this.$nextTick(() => {
          // console.log(this.value, result)
          this.value = result
          this.$emit('togglePaymentType', parseFloat(result.replace(',', '.')))
          if (parseFloat(result.replace(',', '.')) === 0) {
            this.selected = false
          } else {
            this.selected = true
          }
          this.timeoutLifted = true
          // console.log('timeoutLiftedB: ', newVal, oldVal, this.text)
        })
      }, 50),
    },
    watch: {
      value: {
        handler (newVal, oldVal) {
          // return // eslint-disable-line
          if (this.showKeyboard) {
            return
          }
          this.timeoutLifted = false
          this.setFilterDebounced(newVal || '0,00', oldVal)
        },
        immediate: true,
      },
      currentValue: {
        handler (newVal) {
          // if (newVal && (this.student || this.difference)) {
          if (newVal && (this.difference)) {
            this.value = newVal
            this.shouldOpenPopup = true
          }
        },
        immediate: true,
      },
      valueLeft (newVal) {
        // console.log(this.text, newVal, this.previousLastValue, this.previousLastValue !== newVal && newVal > 0 && (this.previousLastValue > newVal || this.previousLastValue < newVal))
        if (this.previousLastValue === 0) {
          this.previousLastValue = newVal
          return
        }
        // console.log(this.previousLastValue, newVal)
        if (this.previousLastValue !== newVal && newVal > 0 && (this.previousLastValue > newVal || this.previousLastValue < newVal)) {
          // console.log('traara', newVal, this.previousLastValue)
          this.setAsDifference = true
          return
        }
        this.setAsDifference = false
      },
    },
  }
  function number_test(n) { return (n - Math. floor(n)) !== 0 } // eslint-disable-line
  </script>

  <style lang='scss' scoped>

    .v-text-field__slot {
    input {
    text-align: right;
    }
    }

  .q-field--standard.q-field--readonly .q-field__control:before {
    border-bottom-style: none !important;
    color: red;
  }
  .podatki p h3 {
    font-size: 12px !important;
  }

  div.q-field__control.relative-position.row.no-wrap {
    padding: 0 12px !important;
  }
  .settings {
    // overflow-y: auto;
    max-height: 61px;
    // margin: 0 0 0 400px;
    // height: calc(100vh - 60px);
    // width: calc(100vw - 400px);
  }
  .hr-breakpoint-mobile .settings {
    padding-left: 20px;
    margin: 0 !important;
  }
  .hr-breakpoint-mobile .settings,
  .menu-closed .settings {
    margin: 0 0 0 0px;
    padding: 0;
    width: 100vw;
  }
  .level-grid {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  .level-grid__input {
    width: 45%;
    display: inline-block;
  }
  </style>